module.exports = __webpack_public_path__ + "img/restart.5489b244.svg";